
	import {
		Component,
		Vue
	} from 'vue-property-decorator';

	// Import Icon
	import { Icon, latLng, latLngBounds } from 'leaflet';
	// Fix the missing icons for Typescript
	type D = Icon.Default & {
		_getIconUrl?: string;
	};
	delete (Icon.Default.prototype as D)._getIconUrl;
	Icon.Default.mergeOptions({
		iconRetinaUrl: require('./assets/marker-orange.png'),
		iconUrl: require('./assets/marker-orange.png'),
		shadowUrl: require('./assets/marker-orange-shadow.png'),
	});
	
	import { LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet';

	Vue.component('l-map', LMap);
	Vue.component('l-tile-layer', LTileLayer);
	Vue.component('l-marker', LMarker);
	Vue.component('l-popup', LPopup);

	import AdvisorsListView from './components/AdvisorsListView.vue';
	import GlobalMixins from './mixins'

	@Component({
		components: {
			AdvisorsListView
		}
	})

	export default class App extends GlobalMixins {
		url: string  = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
		attribution: string = '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors';
		zoom: number = 10;
		lat: number = 52.0116;
		lon: number = 4.3571;
		center: number[] = [this.lat, this.lon];
		scrollWheelZoom: boolean = false;
		mapOptions: any = {
			scrollWheelZoom: false
		};
		markers: any = [];
		pointers: any[] = [];
		searchQueryFinal: string = '';

		clearMarkers(){
			this.markers.forEach((marker: any) => {
				marker.remove();
			});
		}

		created() {
			// Get the Advisors from the Data attribute and populate the data.
			const dataElement = document.getElementById('advisors-vue-app-data')
			if (dataElement && dataElement.dataset.advisors) {
				this.advisors = JSON.parse(dataElement.dataset.advisors)
			}
		};

		mounted() {
			// If a Variable is passed in the URL, immediately start a search.
			const queryString = window.location.search;
			const urlParams = new URLSearchParams(queryString);
			const linkQuery = urlParams.get('linkQuery')
			if (linkQuery) {
				this.$data.searchQuery = linkQuery;
				this.searchStart();
			}
		}

		// Switch between List- and Map view
		switchView(payload: string): void {
			this.resultsView = payload;
			this.searchStart();
		};

		searchStart() {
			// Search functionality for the List
			this.filterAdvisors();
			this.searchQueryFinal = this.searchQuery;

			if (this.resultsView === 'map') {
				setTimeout(() => {
					this.mapSearch();
				}, 1);
			}

			var advisorResults =  (this.$refs.advisorResults as HTMLElement);

		    window.scrollTo({
				top: advisorResults.offsetTop - 130,
				behavior: "smooth",
			});
	
		}

		mapSearch() {
			var filteredList = this.filteredAdvisors;
			var filteredCoordinates = filteredList.map((item) => {
				var popup = {
					name: item.name,
					street: item.billingstreet,
					postal_and_city: item.billingpostalcode + ' ' + item.billingcity,
					phone: item.phone,
					link: item.website
				}
				return { lat: item.billinglatitude, lon: item.billinglongitude, popup: popup }
			});

			var minLat = 100;
			var maxLat = -100;
			var minLon = 100;
			var maxLon = -100;

			// Set the zoom on the Map
			filteredCoordinates.forEach(pointer => {
				var pointerLat = parseFloat(pointer['lat']);
				var pointerLon = parseFloat(pointer['lon']);
				if(pointerLat < minLat){ minLat = pointerLat }
				if(pointerLat > maxLat){ maxLat = pointerLat; }

				if(pointerLon < minLon){ minLon = pointerLon; }
				if(pointerLon > maxLon){ maxLon = pointerLon; }
			});
			
			// Set the corners on which to zoom the view
			var corner1 = latLng(minLat, minLon),
			corner2 = latLng(maxLat, maxLon),
			bounds = latLngBounds(corner1, corner2);

			var myMapRef = (this.$refs.myMap as any);
			myMapRef.mapObject.fitBounds(bounds);

			this.pointers = filteredCoordinates;
		}
	}
